'use client'

import React from 'react'
import SmartLink from '../SmartLink'
import { setCookie } from 'cookies-next'
import {
  REGIONS,
  REGION_COOKIE,
  regionDisplay,
  stripRegionFromPath,
  pathWithRegion,
} from '../../utils/regions'
import usePathnameCompat from '../../utils/usePathnameCompat'
import styles from './styles.module.css'

const COOKIE_MAX_AGE = 60 * 60 * 24 * 365 // 1 year

/**
 * Footer region switcher (item 5).
 *
 * Three real <a href> (Next <Link>) showing region + its DERIVED display
 * currency. Currency cannot be changed independently of region. The active
 * region gets aria-current; switching preserves the current path (swaps the
 * region prefix). Setting the region cookie on click keeps the choice sticky
 * and suppresses the geo-suggest banner.
 */
function RegionSwitcher({ textColor }) {
  const currentPath = usePathnameCompat()
  const { region: activeRegion } = stripRegionFromPath(currentPath)

  const colorStyle = textColor ? { '--region-color': textColor } : undefined

  return (
    <div className={styles.wrapper}>
      <span className={styles.regionLabel} style={colorStyle}>Region</span>
      <div className={styles.regionList}>
        {REGIONS.map((region) => {
          const display = regionDisplay(region)
          const isActive =
            activeRegion === region || (!activeRegion && region === 'us')
          const href = pathWithRegion(currentPath, region)

          return (
            <SmartLink
              key={region}
              href={href}
              className={isActive ? `${styles.regionLink} ${styles.regionLinkActive}` : styles.regionLink}
              style={colorStyle}
              aria-current={isActive ? 'true' : undefined}
              onClick={() =>
                setCookie(REGION_COOKIE, region, {
                  maxAge: COOKIE_MAX_AGE,
                  path: '/',
                })
              }
            >
              {`${display.label} — ${display.currency} ${display.symbol}`}
            </SmartLink>
          )
        })}
      </div>
    </div>
  )
}

export default RegionSwitcher
